module.exports = __webpack_public_path__ + "546fbf3fd03b287c1199a1c437fa4cb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_4.jpg
// module id = 1711
// module chunks = 5